import { render, staticRenderFns } from "./edit-popover.vue?vue&type=template&id=c2d41b40&scoped=true"
import script from "./edit-popover.vue?vue&type=script&lang=js"
export * from "./edit-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d41b40",
  null
  
)

export default component.exports